/* eslint-disable */

import irelandApi from '../irelandApi';

export const getArticlesAboutIgnite = () => (dispatch) => {
  dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_PENDING', payload: []});

  return irelandApi.get('/api/about_ignite?location=website')
    .then((response) => {
      dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_FULFILLED', payLoad: response.data.data});
    })
    .catch((error) => {
      dispatch({type: 'GET_ARTICLES_ABOUT_IGNITE_REJECTED', payLoad: error});
    });
};
